import type { components } from '@trackercop/contracts';
import { Table, THead, TBody, TR, TH, TD } from '@/components/ui/table';
import { Badge } from '@/components/ui/badge';
import { formatDateTime } from '@/lib/format';
import { statusVariant } from './health-tile';

type Dependency = components['schemas']['Dependency'];

interface DependencyTableProps {
  dependencies: Dependency[];
}

export function DependencyTable({ dependencies }: DependencyTableProps) {
  if (dependencies.length === 0) {
    return (
      <div
        className="rounded-md border bg-background p-6 text-sm text-muted-foreground"
        data-testid="dependency-table-empty"
      >
        No dependency probes have run yet.
      </div>
    );
  }
  return (
    <Table data-testid="dependency-table">
      <THead>
        <TR>
          <TH>Component</TH>
          <TH>Status</TH>
          <TH>Latency</TH>
          <TH>Last checked</TH>
          <TH>Message</TH>
        </TR>
      </THead>
      <TBody>
        {dependencies.map((d) => (
          <TR key={d.name} data-testid={`dependency-row-${d.name}`}>
            <TD className="font-mono">{d.name}</TD>
            <TD>
              <Badge variant={statusVariant(d.status)}>{d.status}</Badge>
            </TD>
            <TD className="font-mono text-xs">
              {typeof d.latencyMs === 'number' ? `${d.latencyMs}ms` : '—'}
            </TD>
            <TD className="text-xs text-muted-foreground">
              {formatDateTime(d.lastCheckedAt)}
            </TD>
            <TD className="text-xs text-muted-foreground">{d.message ?? '—'}</TD>
          </TR>
        ))}
      </TBody>
    </Table>
  );
}
